/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { scrollToAnchor } from "../../../../theme/commonStyle";

const familyLawConsultingCheckinStyle = {
  scrollToAnchor,
  formPaper: {
    padding: { xs: "20px", lg: "20px 40px" },
  },
  heading: {
    textAlign: "center",
  },
  grey: {
    backgroundColor: "background.contrast",
  },
  default: {},
};

export default familyLawConsultingCheckinStyle;
